module.exports = __webpack_public_path__ + "static/img/jci.45c843a.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/jci.png
// module id = E4n+
// module chunks = 6